import React from "react";
import { useLang } from "../context";
import { ABOUT } from "../content";

const IMG = "https://images.unsplash.com/photo-1611166705419-30ee8dab0a9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100";

export default function About() {
  const { lang } = useLang();
  const data = ABOUT[lang];
  return (
    <div>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#737373] mb-6">ClassOne Vintage</p>
            <h1 className="serif text-5xl lg:text-6xl leading-tight">{data.title}</h1>
          </div>
          <div className="img-zoom aspect-[4/3] bg-[#F0EBE1]"><img src={IMG} alt="about" className="w-full h-full object-cover" /></div>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-6 lg:px-10 mt-20 space-y-14 pb-10">
        {data.blocks.map((b, i) => (
          <div key={b.h} data-testid={`about-block-${i}`} className="border-l-2 border-[#1A1A1A]/15 pl-7">
            <h2 className="serif text-3xl mb-4">{b.h}</h2>
            <p className="text-base text-[#404040] leading-relaxed">{b.p}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
